// Example in App.js
import React from 'react';
import WiggiWiggiGame from './components/WiggiWiggiGame/WiggiWiggiGame'; // Adjust path if needed
import './App.css'; // Or your main CSS file

function App() {
  return (
    <div className="App">
      <WiggiWiggiGame />
    </div>
  );
}

export default App;